export default function CustomInput({ className, ...props }) {
  return (
    <input
      {...props}
      className={`shadow-sm border-2 border-secondary text-gray-900 sm:text-sm rounded-lg transition-all duration-300 focus:border-primary block w-full p-2.5 outline-none ${className}`}
    />
  );
}
